import { Observable } from 'rxjs';

/** @deprecated In favour of BaasIcon */
export class BarIcon {
    /** Screen reader text */
    srText?: Observable<any> | Promise<any> | any | (() => any);
    /** Position of the icon, 'left' or 'right'. Default is 'left' */
    position?: "left" | "right" | "top" | (() => "left" | "right" | "top");
    /** If the button only has an icon as content */
    iconOnly?: boolean | (() => boolean);
    /** Additional class on the icon */
    class?: string | (() => string);
    /** Additional styles on the icon */
    style?: string | (() => string);
}
